import { call, takeLatest } from 'redux-saga/effects';
import * as constants from './user-tenants.constants';
import * as types from './user-tenants.types';
import * as services from './user-tenants.saga-services';

function* invokeSwitchTenant(action: types.ISwitchTenant) {
  yield call(services.switchTenant, action.payload);
}

function* invokeSearchUserTenants() {
  yield call(services.searchUserTenants);
}

function* invokeAddUserToTenant(action: types.IAddUserToTenantAction) {
  yield call(services.addUserToTenant, action.payload);
}

function* invokeCreateUserTenant(action: types.ICreateUserTenant) {
  yield call(services.createUserTenant, action.payload);
}

export function* watchUserTenantsPageSaga() {
  yield takeLatest(constants.SWITCH_USER_TENANT, invokeSwitchTenant);
  yield takeLatest(constants.ADD_USER_TO_TENANT, invokeAddUserToTenant);
  yield takeLatest(constants.SEARCH_USER_TENANTS, invokeSearchUserTenants);
  yield takeLatest(constants.CREATE_TENANT, invokeCreateUserTenant);
}
